import { memo } from 'react';
import { Button, ModalLayout } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { useDialogKeyboard } from '../../hooks/useDialogKeyboard';

const TITLE_ID = 'unsaved-changes-title';

/**
 * Confirm shown when Cancel is pressed with unsaved edits.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onKeepEditing Closes the dialog; the edits stay.
 * @param {() => void} props.onDiscard Drops the edits.
 */
const UnsavedChangesModal = ({ isOpen, onKeepEditing, onDiscard }) => {
  const { t } = useTranslation('people-access');
  useDialogKeyboard(isOpen, onKeepEditing, TITLE_ID);

  if (!isOpen) return null;

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onKeepEditing}
      useBodyPortal
      title={t('unsavedChanges.title')}
      closeAriaLabel={t('unsavedChanges.close')}
      titleId={TITLE_ID}
      maxWidthClassName="max-w-md"
    >
      <div className="flex flex-col">
        <p className="px-6 py-4 text-sm text-content-secondary">{t('unsavedChanges.message')}</p>
        <div className="flex justify-end gap-2 border-t border-edge px-6 py-4">
          <Button variant="secondary" size="md" data-autofocus onClick={onKeepEditing}>
            {t('unsavedChanges.keepEditing')}
          </Button>
          <Button variant="danger" size="md" onClick={onDiscard}>
            {t('unsavedChanges.discard')}
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default memo(UnsavedChangesModal);
